"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var details_exports = {};
__export(details_exports, {
  DetailsContentNode: () => DetailsContentNode,
  DetailsNode: () => DetailsNode,
  DetailsSummaryNode: () => DetailsSummaryNode
});
module.exports = __toCommonJS(details_exports);
var import_core = require("@tiptap/core");
const DetailsNode = import_core.Node.create({
  name: "details",
  group: "block",
  content: "detailsSummary detailsContent",
  defining: true,
  isolating: true,
  addAttributes() {
    return {
      open: {
        default: false,
        parseHTML: /* @__PURE__ */ __name((element) => element.hasAttribute("open"), "parseHTML"),
        renderHTML: /* @__PURE__ */ __name((attributes) => attributes.open === true ? { open: "" } : {}, "renderHTML")
      }
    };
  },
  parseHTML() {
    return [{ tag: "details" }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["details", (0, import_core.mergeAttributes)(this.options.HTMLAttributes ?? {}, HTMLAttributes), 0];
  }
});
const DetailsSummaryNode = import_core.Node.create({
  name: "detailsSummary",
  content: "inline*",
  defining: true,
  isolating: true,
  selectable: false,
  parseHTML() {
    return [{ tag: "summary" }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["summary", (0, import_core.mergeAttributes)(this.options.HTMLAttributes ?? {}, HTMLAttributes), 0];
  }
});
const DetailsContentNode = import_core.Node.create({
  name: "detailsContent",
  content: "block+",
  defining: true,
  isolating: true,
  selectable: false,
  parseHTML() {
    return [{ tag: 'div[data-type="detailsContent"]' }];
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      (0, import_core.mergeAttributes)(this.options.HTMLAttributes ?? {}, HTMLAttributes, { "data-type": "detailsContent" }),
      0
    ];
  }
});
//# sourceMappingURL=details.js.map
